package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class RefreshTokenResponse(
    val token: String,
    val expiration: String,
    val refreshToken: String
)

@Serializable
@JsExport
data class AccountRequestJwtResponse(
    val jwt: String
)


@Serializable
@JsExport
data class AccountEmailExistsResponse(val exists: Boolean)

@Serializable
@JsExport
class GenericAccountResponse(@SerialName("message") val msg: String)